import goToDefaultPage from '@/helpers/go-to-default-page';
import goToOrderPage from '@/helpers/go-to-order-page';



function returnFullPageMessage(event) {
  const message = {
    button: {
      action: null,
      show: false,
      text: null
    },
    description: null,
    subtitle: null,
    title: null
  };

  if (event.type === 'generic-error') {
    message.description = 'We apologize for the inconvenience. Please try again later.';
    message.subtitle = 'We either spilled the beans or this page doesn\'t exist.';
    message.title = 'Oops!';
  }

  else if (event.type === 'generic-p@t-error') {
    message.description = 'Please ask the waitstaff for assistance.';
    message.subtitle = 'We either spilled the beans or this page doesn\'t exist.';
    message.title = 'Oops!';
  }

  else if (event.type === 'cancelled-payment') {
    message.description = 'To pay your bill, please scan the QR code again.';
    message.subtitle = 'Your payment was cancelled.';
    message.title = 'Payment Cancelled';
  }

  else if (event.type === 'cancelled-payment-due-to-error') {
    message.description = 'To pay your bill, click "View Check" or scan the QR code again.';
    message.subtitle = 'Something went wrong. Any pending payments were cancelled.';
    message.title = 'Oops!';
  }

  else {
    message.description = event.description;
    message.subtitle = event.subtitle;
    message.title = event.title;
  }

  if (event.button) {
    if (event.button === 'goToDefaultPage') {
      message.button.action = goToDefaultPage.redirect;
      message.button.show = goToDefaultPage.shouldShowButton();
      message.button.text = 'Go Back';
    }

    else if (event.button === 'goToOrderPage') {
      message.button.action = goToOrderPage.redirect;
      message.button.show = goToOrderPage.shouldShowButton();
      message.button.text = 'View Check';
    }

    else if (event.button === 'goToTableTopViewBill') {
      message.button.action = goToOrderPage.redirectToTableTopViewBill;
      message.button.show = goToOrderPage.shouldShowButton();
      message.button.text = 'View Check';
    }

    else {
      message.button.action = event.button.action;
      message.button.show = true;
      message.button.text = event.button.text;
    }
  }

  return message;
}



export default returnFullPageMessage;
